export const partners = [
  {
    tier: "medium",
    name: "BCG_Platinion",
    website: "https://bcgplatinion.com/",
    logo: "BCG_Platinion_Online_Color_Light.png",
  },

  {
    tier: "medium",
    name: "Epidemic_sound",
    website: "https://www.epidemicsound.com/",
    logo: "epidemicsound_logo.png",
  },

  {
    tier: "medium",
    name: "SJ AB",
    website: "https://www.sj.se/",
    logo: "sj_logo.png",
  },
];
